import { X, Zap } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal } from "./Reveal";

export default function Comparison() {
  const { t } = useLang();
  return (
    <section id="comparativa" className="border-t lp-hairline bg-[#0c0c0f]">
      <div className="mx-auto max-w-5xl px-4 sm:px-8 py-20 sm:py-32">
        <Reveal>
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#f5a623]">
            {t.compare.kicker}
          </p>
          <h2 className="mt-3 font-black tracking-tighter text-3xl sm:text-4xl">
            {t.compare.title}
          </h2>
        </Reveal>

        <Reveal className="mt-12">
          <div className="overflow-x-auto rounded-2xl border lp-hairline" data-testid="comparison-table">
            <table className="w-full min-w-[560px] text-sm sm:text-base">
              <thead>
                <tr className="border-b lp-hairline bg-white/[0.02]">
                  <th className="p-4 sm:p-5 text-left font-semibold text-[#71717a]" scope="col"></th>
                  <th className="p-4 sm:p-5 text-left font-bold text-[#a1a1aa]" scope="col">
                    <span className="inline-flex items-center gap-2">
                      <X size={16} className="text-red-400/70" />
                      {t.compare.colA}
                    </span>
                  </th>
                  <th className="p-4 sm:p-5 text-left font-bold text-[#f5a623] bg-[#f5a623]/[0.06]" scope="col">
                    <span className="inline-flex items-center gap-2">
                      <Zap size={16} fill="currentColor" />
                      {t.compare.colB}
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {t.compare.rows.map((row) => (
                  <tr key={row.label} className="border-b lp-hairline last:border-b-0">
                    <th className="p-4 sm:p-5 text-left font-semibold text-white" scope="row">
                      {row.label}
                    </th>
                    <td className="p-4 sm:p-5 text-[#a1a1aa]">{row.a}</td>
                    <td className="p-4 sm:p-5 font-semibold text-white bg-[#f5a623]/[0.06]">
                      {row.b}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="mt-5 text-sm text-[#71717a] max-w-2xl">{t.compare.note}</p>
        </Reveal>
      </div>
    </section>
  );
}
